import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { Button, CircularProgress, TextField } from "@material-ui/core";
import axios from "axios";
import api from "../common/api";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ClientChargeInvoices = ({ client_id }) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [filters, setFilters] = useState([
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    []
  ]);
  const [orderColumn, setOrderColumn] = useState("");
  const [orderOrder, setOrderOrder] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceItemTypes, setInvoiceItemTypes] = useState([]);
  const [invoiceLevels, setInvoiceLevels] = useState([]);
  const [invoiceDateRange, setInvoiceDateRange] = useState({
    from: "",
    to: ""
  });
  const [snackBar, setSnackBar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const [showCronMenu, setShowCronMenu] = useState(false);

  const cronJobs = [
    {
      title: "Cargos de Reservas",
      command: "efleet:charges",
      name: "bookings"
    },
    {
      title: "Cargos de Fee",
      command: "efleet:charges",
      name: "serviceCharges"
    },
    {
      title: "Cargos por OT",
      command: "efleet:charges",
      name: "workOrders"
    },
    {
      title: "Facturas de Reservas",
      command: "efleet:invoicing",
      name: "bookings"
    },
    {
      title: "Facturas de Fee",
      command: "efleet:invoicing",
      name: "serviceCharges"
    },
    { title: "Facturas de OT", command: "efleet:invoicing", name: "workOrders" }
  ];

  const handleRunCron = async (command, name) => {
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.set("command", command);
    formData.set("name", name);

    await axios
      .post(api.crons().run(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(() => {
        setSnackBar({
          open: true,
          message: "La tarea comenzó con exito",
          severity: "success"
        });
      })
      .catch(err => {
        setSnackBar({
          open: true,
          message:
            "La ejecución de la tarea falló. Contacte a su administrador",
          severity: "error"
        });
      });
  };
  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0.25rem",
            fontSize: "0.8rem",
            maxWidth: "10rem"
          }
        }
      }
    });

  const fetchData = async (page, filterList, column, order, q_rows) => {
    setIsLoading(true);
    let url = api
      .clientChargeInvoices()
      .index(page + 1, "", "", column, order, q_rows);
    if (filterList[1].length !== 0) {
      url += `&client_business_name=${filterList[1].join(",")}`;
    }
    if (filterList[2].length !== 0) {
      url += `&plate=${filterList[2].join(",")}`;
    }
    if (filterList[5].length !== 0) {
      const [from, to] = filterList[5];
      if (from) url += `&invoice_date_from=${from}`;
      if (to) url += `&invoice_date_to=${to}`;
    }

    if (filterList[8].length !== 0) {
      url += `&work_order_id=${filterList[8].join(",")}`;
    }

    if (client_id) {
      url += `&client_id=${client_id}`;
    }
    if (filterList[9].length !== 0) {
      url += `&status=${filterList[9].join(",")}`;
    }
    if (filterList[15].length !== 0) {
      url += `&level_1=${filterList[15].join(",")}`;
    }
    if (filterList[16].length !== 0) {
      url += `&level_2=${filterList[16].join(",")}`;
    }
    if (filterList[17].length !== 0) {
      url += `&invoice_item_type_name=${filterList[17].join(",")}`;
    }

    const token = localStorage.getItem("userToken");
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(res.data.data);
      setCount(res.data.meta.total);
      setRowsPerPage(res.data.meta.per_page);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchInvoiceItemTypes = async () => {
    const token = localStorage.getItem("userToken");
    try {
      const res = await axios.get(api.invoice_item_types, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const types = res.data.map(item => item.name);
      setInvoiceItemTypes(types);
    } catch (err) {
      console.error(err);
    }
  };
  const fetchInvoiceLevels = async () => {
    const token = localStorage.getItem("userToken");
    try {
      const res = await axios.get(api.invoice_levels, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setInvoiceLevels(res.data.invoice_levels);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchInvoiceItemTypes();
    fetchInvoiceLevels();
  }, []);

  useEffect(() => {
    fetchData(page, filters, orderColumn, orderOrder, rowsPerPage);
  }, [page, filters, orderColumn, orderOrder, rowsPerPage]);

  const handleDownload = () => {
    const token = localStorage.getItem("userToken");
    var formData = new FormData();

    const url = api.clientChargeInvoices().download();
    if (filters[1].length !== 0) {
      formData.set("client_business_name", filters[1].join(","));
    }

    if (filters[2].length !== 0) {
      formData.set("plate", filters[2].join(","));
    }
    if (filters[3].length !== 0) {
      const [from, to] = filters[3];
      if (from) formData.set("invoice_date_from", from);
      if (to) formData.set("invoice_date_to", to);
    }
    // add status filter
    if (filters[9].length !== 0) {
      formData.set("status", filters[9].join(","));
    }
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        window.location.href = response.data;
      })
      .catch(err => {
        console.error(err);
      });
  };
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
        sortDirection: orderColumn === "id" ? orderOrder : null
      }
    },
    {
      name: "client.business_name",
      label: "Cliente",
      options: {
        filter: true,
        filterType: "textField",
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <a
              href={`/clients/${tableMeta.rowData[0]}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
              style={{ color: "#000" }}
            >
              {value}
            </a>
          );
        }
      }
    },
    {
      name: "vehicle.plate",
      label: "Patente",
      options: {
        filter: true,
        filterType: "textField",
        sort: true,
        sortDirection: orderColumn === "plate" ? orderOrder : null
      }
    },
    {
      name: "salesTask.name",
      label: "Articulo venta",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "description",
      label: "Descripcion",
      options: {
        filter: false,
        filterType: "textField",
        sort: false
      }
    },
    {
      name: "invoice_date",
      label: "Fecha factura",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <div>
              <TextField
                label="Fecha desde"
                InputLabelProps={{
                  shrink: true
                }}
                type="date"
                value={filterList[index][0] || ""}
                onChange={event => {
                  filterList[index][0] = event.target.value;
                  onChange(filterList[index], index, column);
                }}
                style={{ width: "45%" }}
              />
              <TextField
                label="Fecha hasta"
                type="date"
                InputLabelProps={{
                  shrink: true
                }}
                value={filterList[index][1] || ""}
                onChange={event => {
                  filterList[index][1] = event.target.value;
                  onChange(filterList[index], index, column);
                }}
                style={{ width: "45%" }}
              />
            </div>
          )
        },
        customFilterListRender: v => {
          if (!v || v.length === 0) return null;
          const [from, to] = v;
          return [`Desde: ${from || "..."}`, `Hasta: ${to || "..."}`];
        },
        onFilterChipClose: () => {
          setInvoiceDateRange({ from: "", to: "" });
          const newFilterList = [...filters];
          newFilterList[3] = [];
          setFilters(newFilterList);
        },
        sort: true,
        sortDirection: orderColumn === "date" ? orderOrder : null
      }
    },
    {
      name: "invoice_number",
      label: "Factura",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "service_charge.name",
      label: "Cargo",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "price",
      label: "Subtotal",
      options: {
        filter: false,
        sort: true,
        sortDirection: orderColumn === "price" ? orderOrder : null,
        customBodyRender: value => {
          return <>${value}</>;
        }
      }
    },
    {
      name: "status",
      label: "Estado",
      options: {
        filter: true,
        filterType: "select",
        filterOptions: {
          names: ["pending", "invoiced"]
        },
        sort: false
      }
    },
    {
      name: "work_order_id",
      label: "OT",
      options: {
        filter: false,
        display: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <a
              href={`/work-order/${value}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {value}
            </a>
          );
        }
      }
    },
    {
      name: "work_order_task",
      label: "Tarea OT",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "voucher_sap_code",
      label: "Factura Compra SAP",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "start_date",
      label: "Fecha inicio",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "end_date",
      label: "Fecha fin",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "level_1.name",
      label: "Agrupacion 1",
      options: {
        filter: true,
        filterType: "select",
        filterOptions: {
          names: invoiceLevels
            .filter(level => level.level === 1)
            .map(level => level.name)
        },
        display: false
      }
    },
    {
      name: "level_2.name",
      label: "Agrupacion 2",
      options: {
        filter: true,
        filterType: "select",
        filterOptions: {
          names: invoiceLevels
            .filter(level => level.level === 2)
            .map(level => level.name)
        },
        display: false
      }
    },
    {
      name: "invoice_item_type.name",
      label: "Concepto factura",
      options: {
        filter: true,
        filterType: "select",
        filterOptions: {
          names: invoiceItemTypes.map(type => type)
        },
        display: false
      }
    }
  ];

  const options = {
    serverSide: true,
    count,
    page,
    rowsPerPage,
    selectableRows: false,
    onChangePage: setPage,
    onChangeRowsPerPage: number => setRowsPerPage(number),
    onColumnSortChange: (column, direction) => {
      setOrderColumn(column);
      setOrderOrder(direction);
    },
    download: true,
    onDownload: () => {
      handleDownload();
      return false;
    },

    customFilterDialogFooter: filterList => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => {
              setPage(0);
              setFilters(filterList);
            }}
          >
            Aplicar
          </Button>
        </div>
      );
    },

    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress size={24} />
        ) : (
          "No hay datos disponibles"
        )
      }
    }
  };

  return (
    <MuiThemeProvider theme={getMuiTheme()}>
      <MUIDataTable
        title="Cargos"
        data={data}
        columns={columns}
        options={options}
      />
    </MuiThemeProvider>
  );
};

export default ClientChargeInvoices;
